<template>
  <div>
    <div class="d-flex align-center">
      <h2>{{ $t('features.nursery-web-setting-download-list') }}</h2>
      <v-spacer />
      <v-btn
        @click="listFiles"
        :loading="loading"
        color="primary"
        variant="outlined"
      >
        <v-icon start>mdi-sync</v-icon>
        Refresh
      </v-btn>
    </div>

    <v-card variant="flat" class="mt-6 pa-2" color="grey-lighten-4">
      <v-container>
        <v-row align="center">
          <v-col cols="3">
            <v-select
              :items="statusItems"
              v-model="searchFilters.status"
              label="Status"
              variant="outlined"
              density="compact"
              :disabled="loading"
              hide-details
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              :items="categoryItems"
              v-model="searchFilters.category"
              label="Category"
              variant="outlined"
              density="compact"
              :disabled="loading"
              hide-details
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-btn
              @click="listFilesFront"
              :loading="loading"
              color="primary"
              variant="flat"
              class="search-button"
              >{{ $t('common.search') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div class="mt-6 d-flex align-center">
      <h5>{{ list && list.count ? list.count : 0 }} items</h5>
    </div>

    <div class="mt-2">
      <v-table>
        <thead>
          <tr>
            <th>Status</th>
            <th>Updated</th>
            <th>Category</th>
            <th>Filename</th>
            <th>Download</th>
          </tr>
        </thead>
        <tbody v-if="list">
          <tr v-for="(item, i) in list.data" :key="i">
            <td>
              <v-chip v-if="item.status == 'completed'" color="success" variant="flat"
                >Completed</v-chip
              >
              <v-chip v-if="item.status == 'inProgress'" color="warning" variant="flat"
                >In Progress</v-chip
              >
              <v-chip v-if="item.status == 'failed'" color="error" variant="flat"
                >Failed</v-chip
              >
              <v-chip v-if="item.status == 'timeout'" color="error" variant="flat"
                >Timeout</v-chip
              >
            </td>
            <td>{{ formatDate(item.updatedAt) }}</td>
            <td>
              {{
                categoryItems.find((c) => c.value === (item.category ?? ""))?.title ?? ""
              }}
            </td>
            <td>{{ item.filename }}</td>
            <td>
              <v-btn
                :href="item.url ?? undefined"
                :disabled="item.status != 'completed'"
                :loading="loading"
                color="primary"
                small
                variant="flat"
              >
                <v-icon start>mdi-tray-arrow-down</v-icon>
                {{ $t('common.download') }}
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-table>

      <v-pagination
        class="mt-6"
        v-if="list && list.count"
        v-model="page"
        @input = "pageClick"
        :length="Math.ceil(list.count / searchFilters.limit)"
        color="primary"
      ></v-pagination>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LocalDataService from "@/service/LocalDataService";
import { batchStreamLogModule } from "@/store/dataModules/batchStreamLogModule";
import { BatchStreamLogListResponse } from "chaild-api/lib";
import { categoryItems, statusItems } from "@/constants/batchStreamLog";
import dayjs from "dayjs";

export default defineComponent({
  name: "BatchStreamLogList",

  async mounted() {
    const batchStreamLogListPage = sessionStorage.getItem('batchStreamLogListPage');
    const batchStreamLogListStatus = sessionStorage.getItem('batchStreamLogListStatus');
    const batchStreamLogListCategory = sessionStorage.getItem('batchStreamLogListCategory');
    if (batchStreamLogListStatus) this.searchFilters.status = batchStreamLogListStatus;
    if (batchStreamLogListCategory) this.searchFilters.category = batchStreamLogListCategory;
    if (batchStreamLogListPage) this.page = Number(batchStreamLogListPage);
    await this.listFiles();
  },

  data() {
    return {
      loading: false,
      searchFilters: {
        action: "export",
        category: "",
        skip: 0,
        limit: 20,
        status: "",
      },
      categoryItems: categoryItems,
      statusItems: statusItems,
    };
  },

  computed: {
    list: function (): BatchStreamLogListResponse | null {
      return batchStreamLogModule.list;
    },
    page: {
      get(): number {
        if (this.searchFilters.skip == 0) {
          return 1;
        }
        return Math.ceil(
          this.searchFilters.skip / (this.searchFilters.limit - 1)
        );
      },
      set(value: number) {
        this.searchFilters.skip = (value - 1) * this.searchFilters.limit;
        this.listFiles();
      },
    },
  },

  methods: {
    async pageClick(pageNumber) {
      if (pageNumber) sessionStorage.setItem('batchStreamLogListPage', String(pageNumber));
    },
    async listFilesFront() {
      this.page = 1;
      await this.listFiles();
    },
    async listFiles() {
      this.loading = true;
      if (this.searchFilters.status) sessionStorage.setItem('batchStreamLogListStatus', this.searchFilters.status); else  sessionStorage.setItem('batchStreamLogListStatus', '');
      if (this.searchFilters.category) sessionStorage.setItem('batchStreamLogListCategory', this.searchFilters.category); else  sessionStorage.setItem('batchStreamLogListCategory', '');
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await batchStreamLogModule
          .listFiles({
            nurseryId,
            ...this.searchFilters,
          })
          .catch();
      }
      this.loading = false;
    },
    formatDate(value: string): string {
      if (!value) {
        return "";
      }
      return dayjs(value).format("DD/MM/YYYY HH:mm");
    },
  },
});
</script>
